module.exports = __webpack_public_path__ + "img/notes-2.a8d8a825.png";